import React, { useState } from 'react';
import WordHelp from './WordHelp';
import './WordListPage.css';

const WordListPage = ({ template, onSubmit, onBackToCover, onGenerateNew }) => {
    const [userWords, setUserWords] = useState({});

    // Safety check - if no template, don't render
    if (!template || !template.wordList) {
        return <div>Loading...</div>;
    }

    const handleWordChange = (number, value) => {
        setUserWords({
            ...userWords,
            [number]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(userWords);
    };

    const allWordsFilled = template.wordList.every((item) => userWords[item.number]?.trim());

    return (
        <div className="word-list-page-container">
            <div className="word-list-content">
                <h1>WORD LIST</h1>
                <p className="page-instructions typewriter-text">
                    Fill in the blanks below WITHOUT peeking at the story!
                </p>
                
                <div className="generate-new-container">
                    <button 
                        type="button"
                        onClick={onGenerateNew}
                        className="generate-new-button booklet-title"
                    >
                        🎲 GENERATE NEW
                    </button>
                    <p className="generate-new-hint">
                        Looks familiar? Get a fresh story!
                    </p>
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="word-form">
                        {template.wordList.map((item) => (
                            <div key={item.number} className="word-form-item">
                                <label className="typewriter-text">
                                    <span className="word-form-number">{item.number}.</span>
                                    <span className="word-form-prompt">{item.prompt}:</span>
                                    <WordHelp prompt={item.prompt} />
                                </label>
                                <input
                                    type="text"
                                    value={userWords[item.number] || ''}
                                    onChange={(e) => handleWordChange(item.number, e.target.value)}
                                    className="word-form-input fill-in-blank"
                                    placeholder="Write here..."
                                    autoComplete="off"
                                    spellCheck="false"
                                />
                            </div>
                        ))}
                    </div>
                    
                    <div className="button-group">
                        <button 
                            type="button"
                            onClick={onBackToCover}
                            className="back-to-cover-button booklet-title"
                        >
                            ← BACK TO HOME
                        </button>
                        
                        <button 
                            type="submit" 
                            className="see-story-button booklet-title"
                            disabled={!allWordsFilled}
                        >
                            📖 SEE MY STORY!
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default WordListPage;